import { tenantQueryKeys } from 'queries/queryKeys/tenantKeys';
import { useMutation, useQueryClient } from 'react-query';
import { CompleteOnboarding, type TenantResponse } from 'services/TenantService';

/**
 * Mutation recording that the first-run onboarding flow has been completed, taking the organization
 * name to save with it, if one was given.
 *
 * Writes the updated tenant straight into the tenant query cache. The onboarding route guard
 * reads that cache, and `useTenant` is configured never to go stale, so without this the guard
 * would still see an incomplete tenant and send the user back into the flow the moment onboarding
 * navigates into the app.
 */
export const useCompleteOnboarding = () => {
    const queryClient = useQueryClient();

    return useMutation(CompleteOnboarding, {
        onSuccess: (tenant: TenantResponse) => {
            queryClient.setQueryData(tenantQueryKeys.tenant, tenant);
        }
    });
};
